var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 3C19.2864 3 21.75 5.32194 21.75 8.25C21.75 12.1749 19.3124 15.3611 17.0117 17.5059C15.8491 18.5896 14.6891 19.4378 13.8213 20.0146C13.3867 20.3036 13.0231 20.5259 12.7666 20.6768C12.6386 20.7521 12.5374 20.8102 12.4668 20.8496C12.4315 20.8693 12.4031 20.884 12.3838 20.8945L12.3613 20.9072L12.3555 20.9111L12.3525 20.9121C12.1326 21.0289 11.8674 21.0289 11.6475 20.9121L11.6445 20.9111L11.6387 20.9072L11.6162 20.8945C11.5969 20.884 11.5685 20.8693 11.5332 20.8496C11.4626 20.8102 11.3614 20.7521 11.2334 20.6768C10.9769 20.5259 10.6133 20.3036 10.1787 20.0146C9.31091 19.4378 8.15088 18.5896 6.98828 17.5059C4.68761 15.3611 2.25 12.1749 2.25 8.25C2.25 5.32194 4.7136 3 7.6875 3C9.43638 3 11.0023 3.79925 12 5.05176C12.9977 3.79925 14.5636 3 16.3125 3Z",
    fill: "#eb0d3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.478fa784efc16307675eea2debc723af.svg";
export { ForwardRef as ReactComponent };